import { useEffect } from "react";

interface DownloadModalProps {
  open: boolean;
  appName: string;
  onClose: () => void;
}

export default function DownloadModal({ open, appName, onClose }: DownloadModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/70 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative w-full max-w-md rounded-lg bg-background-50 border border-background-200 p-6 animate-fadeUp">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-download-cloud-2-line text-xl"></i>
            </span>
            <div>
              <h2 className="text-base font-semibold text-foreground-900">下载 {appName}</h2>
              <p className="text-xs text-foreground-500 mt-0.5">安装包信息已准备</p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-500 hover:bg-background-100 cursor-pointer"
            aria-label="关闭"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        <div className="mt-5 rounded-md bg-secondary-50 border border-secondary-200 p-4">
          <p className="text-sm text-secondary-900 leading-6">
            当前站点为内容演示版本，应用下载链接尚未接入真实分发渠道。后续接入官方下载地址后，此处将直接跳转应用商店或安装包地址。
          </p>
        </div>

        <ul className="mt-4 space-y-2 text-xs text-foreground-600">
          <li className="flex items-center gap-2">
            <i className="ri-check-line text-accent-600"></i>
            建议从官方应用商店或开发者官网获取安装包
          </li>
          <li className="flex items-center gap-2">
            <i className="ri-check-line text-accent-600"></i>
            安装前请确认系统版本与应用兼容性
          </li>
        </ul>

        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md border border-background-300 text-sm text-foreground-700 whitespace-nowrap hover:border-primary-300 cursor-pointer"
          >
            我知道了
          </button>
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 cursor-pointer"
          >
            确认下载（演示）
          </button>
        </div>
      </div>
    </div>
  );
}